export default "__VITE_ASSET__WH8bXfdM__"